"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ctxTarget = ctxTarget;
exports.computeSourceHash = computeSourceHash;
exports.buildCtxFrontmatter = buildCtxFrontmatter;
exports.buildCtxShell = buildCtxShell;
exports.buildCtxSource = buildCtxSource;
const crypto = __importStar(require("crypto"));
const dist_1 = require("../../core/dist");
const frontmatterUtils_1 = require("../../core/dist/frontmatterUtils");
/**
 * Canonical on-disk target for the global ctx doc. Identity is the frontmatter id
 * (`loom-ctx`); the filename is the positional flat `ctx.md` (ctx-naming convention).
 * ctx is **global-only** (ctx-surface-parity): one `loom/ctx.md` per project — weave
 * ctx is retired, so this takes no scope.
 */
function ctxTarget() {
    return { ctxId: 'loom-ctx', relPath: 'loom/ctx.md', title: 'Loom — Global Context' };
}
/** Stable content hash of the assembled source, stored as `source_hash` for idempotency. */
function computeSourceHash(source) {
    return crypto.createHash('sha1').update(source, 'utf8').digest('hex');
}
/**
 * Canonical frontmatter object for the global ctx doc. parent_id is always null
 * (ctx is positional). `last_refreshed` is the honest recency signal surfaced to the
 * human (ctx has no trustworthy staleness flag — see ctx-surface-parity design §4).
 */
function buildCtxFrontmatter(args) {
    const today = args.today ?? (0, dist_1.today)();
    return {
        type: 'ctx',
        id: args.ctxId,
        title: args.title,
        status: 'active',
        created: args.created ?? today,
        updated: today,
        version: args.version,
        tags: ['ctx', 'summary'],
        parent_id: null,
        requires_load: [],
        source_hash: args.sourceHash,
        last_refreshed: today,
    };
}
/** A ctx shell (frontmatter + H1) for an agent to fill the body of. */
function buildCtxShell(target, version, sourceHash, today) {
    const fm = buildCtxFrontmatter({ ctxId: target.ctxId, title: target.title, version, sourceHash, today });
    return `${(0, frontmatterUtils_1.serializeFrontmatter)(fm)}\n# ${target.title}\n`;
}
/**
 * Assemble the *source* an agent summarises into the global ctx doc. Pure — reads only
 * LoomState. Lists active/implementing weaves + their threads, one line each.
 */
function buildCtxSource(state) {
    const lines = [`Workspace: ${state.loomName}`];
    for (const weave of state.weaves) {
        const ws = (0, dist_1.getWeaveStatus)(weave);
        if (ws !== 'ACTIVE' && ws !== 'IMPLEMENTING')
            continue;
        lines.push('', `## ${weave.id} (${ws})`);
        for (const thread of weave.threads) {
            const ts = (0, dist_1.getThreadStatus)(thread);
            const label = thread.design?.title ?? thread.idea?.title ?? '(no design/idea)';
            lines.push(`- ${thread.id} (${ts}): ${label}`);
        }
    }
    if (lines.length === 1)
        lines.push('', '(no active or implementing weaves)');
    return lines.join('\n');
}
